export default __webpack_public_path__ + "static/media/guide.4cb2126c.jpeg";